/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseTerminalsInner
 */
export interface GetConfig200ResponseTerminalsInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTerminalsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTerminalsInner
     */
    integratorId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTerminalsInner
     */
    paymentMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseTerminalsInner
     */
    terminalId: string;
}

/**
 * Check if a given object implements the GetConfig200ResponseTerminalsInner interface.
 */
export function instanceOfGetConfig200ResponseTerminalsInner(value: object): value is GetConfig200ResponseTerminalsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('integratorId' in value) || value['integratorId'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseTerminalsInnerFromJSON(json: any): GetConfig200ResponseTerminalsInner {
    return GetConfig200ResponseTerminalsInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseTerminalsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseTerminalsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'integratorId': json['integratorId'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'terminalId': json['terminalId'],
    };
}

export function GetConfig200ResponseTerminalsInnerToJSON(json: any): GetConfig200ResponseTerminalsInner {
    return GetConfig200ResponseTerminalsInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseTerminalsInnerToJSONTyped(value?: GetConfig200ResponseTerminalsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'integratorId': value['integratorId'],
        'paymentMethod': value['paymentMethod'],
        'terminalId': value['terminalId'],
    };
}

